import FirstPage from "./firstPage";

export default FirstPage;
